import { CommonModule } from '@angular/common';
import { HelperComponent } from './helper.component';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MarkdownModule } from 'ngx-markdown';
import { TransactionHelperActionsRepository } from '../../../pages/instructions/components/transaction-helper/transaction-helper-actions/transaction-helper-actions-repository';
import { WrapperModule } from '../wrapper/wrapper.module';

@NgModule({
    declarations: [HelperComponent],
    imports: [CommonModule, MatIconModule, MarkdownModule.forRoot(), WrapperModule],
    exports: [HelperComponent],
    providers: [TransactionHelperActionsRepository]
})
export class HelperModule {}
